export const createEventTrigger = (eventType, eventName) => {
    return () => {
        window.AWSMA.ready(() => {
            document.dispatchEvent(new CustomEvent(window.AWSMA.TRIGGER_EVENT, {
                detail: {
                    event: {
                        type: eventType,
                        name: eventName,
                    },
                },
            }));
        });
    };
};
export const triggerAnalyticsEvent = (eventType, eventPath) => {
    try {
        const triggerAAEvent = createEventTrigger(eventType, eventPath);
        triggerAAEvent();
    }
    catch (error) {
        console.error('Failed to trigger analytics event:', error);
    }
};
